interface RequiredFieldStylesParams {
  readOnly?: boolean;
  isVisible?: boolean;
  isEmpty: boolean;
}

export const getRequiredFieldStyles = ({
  readOnly = false,
  isVisible = true,
  isEmpty,
}: RequiredFieldStylesParams) => {
  if (readOnly || !isVisible || !isEmpty) {
    return undefined;
  }

  return {
    input: {
      borderColor: "var(--mantine-color-error)",
    },
  };
};
